<span>{{ value.caption }}</span>
<span *ngIf="value.description" class="tip description">{{
  value.description
}}</span>
<div class="sort-icon" *ngIf="value.dataField === 'symbol'">
  <button
    class="sort-icon__off"
    *ngIf="symbolSort === 'off'"
    (click)="toggleSortBySymbol()"
  >
    <i class="material-icons sort-icon__off-up"> keyboard_arrow_up </i>
    <i class="material-icons sort-icon__off-down"> keyboard_arrow_down </i>
  </button>
  <button
    class="sort-icon__asc"
    *ngIf="symbolSort === 'asc'"
    (click)="toggleSortBySymbol()"
  >
    <i class="material-icons direction-icon">arrow_upward</i>
  </button>
  <button
    class="sort-icon__desc"
    *ngIf="symbolSort === 'desc'"
    (click)="toggleSortBySymbol()"
  >
    <i class="material-icons direction-icon">arrow_downward</i>
  </button>
</div>
<tui-loader
  class="loader"
  [showLoader]="showLoader"
  [inheritColor]="true"
  [overlay]="showLoader"
  *ngIf="value.dataField === 'optvol' && currentPreset === 1"
>
  <i
    (click)="toggleDirection()"
    *ngIf="direction === 'desc' && symbolSort === 'off'"
    class="material-icons direction-icon"
    >arrow_downward</i
  >
  <i
    (click)="toggleDirection()"
    *ngIf="direction === 'asc' && symbolSort === 'off'"
    class="material-icons direction-icon"
    >arrow_upward</i
  >
  <button
    class="sort-icon__off main-column-sort-off"
    *ngIf="symbolSort !== 'off'"
    (click)="toggleDirection()"
  >
    <i class="material-icons sort-icon__off-up"> keyboard_arrow_up </i>
    <i class="material-icons sort-icon__off-down"> keyboard_arrow_down </i>
  </button>
</tui-loader>

<tui-loader
  class="loader"
  [showLoader]="showLoader"
  [inheritColor]="true"
  [overlay]="showLoader"
  *ngIf="value.dataField === 'ivx30hv20' && currentPreset === 2"
>
  <i
    (click)="toggleDirection()"
    *ngIf="direction === 'desc' && symbolSort === 'off'"
    class="material-icons direction-icon"
    >arrow_downward</i
  >
  <i
    (click)="toggleDirection()"
    *ngIf="direction === 'asc' && symbolSort === 'off'"
    class="material-icons direction-icon"
    >arrow_upward</i
  >
  <button
    class="sort-icon__off main-column-sort-off"
    *ngIf="symbolSort !== 'off'"
    (click)="toggleDirection()"
  >
    <i class="material-icons sort-icon__off-up"> keyboard_arrow_up </i>
    <i class="material-icons sort-icon__off-down"> keyboard_arrow_down </i>
  </button>
</tui-loader>

<tui-loader
  class="loader"
  [showLoader]="showLoader"
  [inheritColor]="true"
  [overlay]="showLoader"
  *ngIf="value.dataField === 'ivr30' && currentPreset === 3"
>
  <i
    (click)="toggleDirection()"
    *ngIf="direction === 'desc' && symbolSort === 'off'"
    class="material-icons direction-icon"
    >arrow_downward</i
  >
  <i
    (click)="toggleDirection()"
    *ngIf="direction === 'asc' && symbolSort === 'off'"
    class="material-icons direction-icon"
    >arrow_upward</i
  >
  <button
    class="sort-icon__off main-column-sort-off"
    *ngIf="symbolSort !== 'off'"
    (click)="toggleDirection()"
  >
    <i class="material-icons sort-icon__off-up"> keyboard_arrow_up </i>
    <i class="material-icons sort-icon__off-down"> keyboard_arrow_down </i>
  </button>
</tui-loader>

<tui-loader
  class="loader"
  [showLoader]="showLoader"
  [inheritColor]="true"
  [overlay]="showLoader"
  *ngIf="value.dataField === 'ivx30chg' && currentPreset === 4"
>
  <i
    (click)="toggleDirection()"
    *ngIf="direction === 'desc' && symbolSort === 'off'"
    class="material-icons direction-icon"
    >arrow_downward</i
  >
  <i
    (click)="toggleDirection()"
    *ngIf="direction === 'asc' && symbolSort === 'off'"
    class="material-icons direction-icon"
    >arrow_upward</i
  >
  <button
    class="sort-icon__off main-column-sort-off"
    *ngIf="symbolSort !== 'off'"
    (click)="toggleDirection()"
  >
    <i class="material-icons sort-icon__off-up"> keyboard_arrow_up </i>
    <i class="material-icons sort-icon__off-down"> keyboard_arrow_down </i>
  </button>
</tui-loader>

<tui-loader
  class="loader"
  [showLoader]="showLoader"
  [inheritColor]="true"
  [overlay]="showLoader"
  *ngIf="value.dataField === 'd10' && currentPreset === 5"
>
  <i
    (click)="toggleDirection()"
    *ngIf="direction === 'desc' && symbolSort === 'off'"
    class="material-icons direction-icon"
    >arrow_downward</i
  >
  <i
    (click)="toggleDirection()"
    *ngIf="direction === 'asc' && symbolSort === 'off'"
    class="material-icons direction-icon"
    >arrow_upward</i
  >
  <button
    class="sort-icon__off main-column-sort-off"
    *ngIf="symbolSort !== 'off'"
    (click)="toggleDirection()"
  >
    <i class="material-icons sort-icon__off-up"> keyboard_arrow_up </i>
    <i class="material-icons sort-icon__off-down"> keyboard_arrow_down </i>
  </button>
</tui-loader>
